import styled from 'styled-components'
import tw from 'tailwind-styled-components'

export const HeaderContainer = styled.div`
  width: 100%;
  background-color: #151518;
  position: fixed;
  top: 0;
  z-index: 50;
  padding-left: 15px;
  padding-right: 15px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 8px 0px;
`

export const DesktopContainer = tw.div`
  flex 
  md:grid 
  md:grid-cols-3 
  space-between 
  items-center 
  my-14
`

export const WalletSection = tw.div`
  lg:justify-self-center 
  lg:col-start-2
`

export const RightSection = tw.div`
  flex 
  justify-end 
  gap-10 
  lg:col-start-3
`

export const ControlsGroup = tw.div`
  flex 
  gap-x-10
`

export const MobileContainer = tw.div`
  flex 
  justify-between 
  md:hidden 
  gap-x-4 
  py-10
`

export const LogoContainer = tw.div`
  flex 
  items-center
`

export const WalletWrapper = tw.div`
  w-200
`
